<template>
  <b-modal 
    no-close-on-backdrop
    size="lg" 
    centered 
    ok-only
    ok-title="Fechar"
    ok-variant="danger"
    title="Detalhes do cliente"
    v-model="open"
  >
    <div class="container">
      <b-row>
        <b-col cols="12" class="mb-4">
          <h4 class="text-center">
            Dados do cliente
          </h4>
        </b-col>
  
        <b-col cols="12" md="4" class="mb-3">
          <p class="font-weight-bold">Nome: </p>
          <p v-if="user.client">
            {{ user.client.first_name }} {{ user.client.last_name }} 
          </p> 
          <p v-if="user.professional">
            {{ user.professional.name }}
          </p> 
          <p v-if="user.company">
            {{ user.company.nome_fantasia }}
          </p> 
        </b-col>

        <b-col cols="12" md="4" class="mb-3">
          <p class="font-weight-bold">Email: </p>
          <p>
            {{ client.email }}
          </p> 
        </b-col>

        <b-col cols="6" md="4" class="mb-3">
          <p class="font-weight-bold">Telefone: </p>
          <p>
            {{ phone }}
          </p> 
        </b-col>

        <b-col cols="6" md="4" class="mb-3">
          <p class="font-weight-bold">CPF: </p>
          
          <p v-if="user.client">
            {{ client.client.cpf }}
          </p> 
          
          <p v-if="user.professional">
            {{ client.professional.cpf }}
          </p> 
          
          <p v-if="user.company">
            {{ client.company.cnpj }}
          </p> 
        </b-col>

        <b-col cols="6" md="4" class="mb-3">
          <p class="font-weight-bold">RG: </p>
          <p  v-if="user.client">
            {{ client.client.rg }}
          </p> 
        </b-col>

        <b-col cols="6" md="4" class="mb-3">
          <p class="font-weight-bold">Criado em: </p>
          <p>
            {{ formatDate(client.created_at) }}
          </p> 
        </b-col>
  
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12" class="mb-4">
          <h4 class="text-center">
            Carteira
          </h4>
        </b-col>

        <b-col cols="4" md="2" class="mb-3">
          <p class="font-weight-bold">Bloqueado: </p>
          <p v-if="user.block == 0">
            Não
          </p> 
          <p v-else>Sim</p>
        </b-col>

        <b-col cols="4" md="2" class="mb-3">
          <p class="font-weight-bold">Crédito do cliente: </p>
          <p>
            R$ {{ formatMoneyUn(user.limit) }}
          </p> 
        </b-col>

        <b-col cols="4" md="2" class="mb-3">
          <p class="font-weight-bold">Total em aberto: </p>
          <p>
            R$ {{ formatMoneyUn(user.spent) }}
          </p> 
        </b-col>

        <b-col cols="4" md="2" class="mb-3">
          <p class="font-weight-bold">Saldo: </p>
          <p>
            R$ {{ formatMoneyUn(user.balance) }}
          </p> 
        </b-col>

        <b-col cols="4" md="2" class="mb-3">
          <p class="font-weight-bold">Vencimento: </p>
          <p>
            {{ user.due }}
          </p> 
        </b-col>
      </b-row>

      <b-row class="d-block mt-2">
        <b-col cols="12" class="mb-4">
          <h4 class="text-center">
            Histórico dos últimos 15 pedidos
          </h4>
        </b-col>
   
        <b-col cols="12" class="mt-4">
          <b-table
            striped
            responsive
            hover
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>

            <template #cell(payment_value)="data">
              R$ {{ formatMoneyUn(data.item.payment_value) }}
            </template>

            <template #cell(date)="data">
              {{ formatDateNew(data.item.date) }}
            </template>

            <template #cell(action)="data">
              <div class="ml-5">
                <b-button
                variant="outline-dark"
                size="sm"
                title="Detalhes do pedido"
                class="mr-2 mb-2"
                @click="$refs.orderDetails.toggleOpen({ orderId: data.item.id_payment, uuid: data.item.uuid, dataModal: data.item})"
                >
                  <i class="fas fa-eye"></i>
                </b-button>
              </div>  
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
    
    <OrderDetails 
      ref="orderDetails"
    />
  </b-modal>
</template>


<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import OrderDetails from 'Components/Order/OrderDetails.vue';

export default {
  name: 'DetailsClient',
  mixins: [makeToast],
  components: {
    OrderDetails,
  },

  data() {
    return {
      loading: false, 
      open: false,
      user: [],
      client: [],
      name: '',
      phone:'',
      table: {
        headers: [
          {
            key: 'id_payment_book',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'uuid',
            label: 'Nº pedido',
            sortable: false,
          },
          {
            key: 'payment_value',
            label: 'Valor ',
            sortable: false,
          },
          {
            key: 'date',
            label: 'Data',
            sortable: false,
          },
          {
            key: 'action',
            label: 'Detalhes do pedido',
            sortable: false,
          },
        ],
        records: [],
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  methods: {
    ...mapActions('shopkeeper', [
      'historyClientWallet',
      'getClientApp'
    ]),
    toggleOpen({ user = []}) {
      this.open = !this.open;
      this.user = user;
      this.historySale();
      this.getClient();
    },

    formatMoneyUn(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
    },

    formatDate(value){
      if(value != undefined) {
        let newData = value.slice(0,-17);
        let split = newData.split('-');
        newData = split[2]+'/'+split[1]+'/'+split[0];
        return newData;
      }
    },
    formatDateNew(value){
        let newData = value.slice(0,-9);
        let split = newData.split('-');
        newData = split[2]+'/'+split[1]+'/'+split[0]
        return newData;
    },

    getClient(){
      this.$store.dispatch('startLoader');
        this.getClientApp(this.user.user_id)
        .then((response) => {
          this.client = response.data.data;
          this.phone = this.client.phone[0] ? this.client.phone[0].number : '';
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados, favor atualizar a pagina',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });

    },

    historySale(){
      this.$store.dispatch('startLoader');
        this.historyClientWallet(this.user.id)
        .then((response) => {
          this.table.records = response.data;
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados, favor atualizar a pagina',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    }
  }
}
</script>
